<div style="padding: 10px">
  @if (showEventUploadTitle()) {
    <h2>{{'event.upload_image' | translate}}
      @if (page() === 'event') {
        <span> *</span>
      }
    </h2>
  }
  @if (isProfilePage()) {
    <h2>{{'main.profileupload' | translate}}</h2>
  }
  @if (isOrgPage()) {
    <h2>{{'main.logoUpload' | translate}}</h2>
  }

<div style="display: flex">
  @if (img().length === 0) {
    <div style="width: 200px; margin-right: 15px">
      @if (isProfilePage()) {
        <img   src="../../../../assets/images/user_upload.svg"/>
      }
      @if (!isProfilePage()) {
        <img src="../../../../assets/images/new-upload-icon.svg"/>
      }
    </div>
  }

  <div class="change-avatar-container">
    @if (!hideRatioPages().includes(page())) {
      @if (openCropper()) {
        <div>
          <image-cropper
            [imageChangedEvent]="imageChangedEvent()"
            [maintainAspectRatio]="useRatio()"
            [roundCropper]="page()==='profile'"
            [aspectRatio]="ratioX() / ratioY()"
            output="blob"
            format="png"
            (imageCropped)="imageCroppedInFile($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
            [ngClass]="{'w-200': zoomScale()===200, 'w-300': zoomScale()===300, 'w-400': zoomScale()===400,
        'w-500': zoomScale()===500}"
          ></image-cropper>
        </div>
      }
    }
    @if (hideRatioPages().includes(page())) {
      @if (openCropper() && imageChangedEvent() && !imageFromCollection()) {
        <div>
          <image-cropper
            [imageChangedEvent]="imageChangedEvent()"
            [maintainAspectRatio]="useRatio()"
            [roundCropper]="page()==='profile'"
            [aspectRatio]="ratioX() / ratioY()"
            output="blob"
            format="png"
            (imageCropped)="imageCroppedInFile($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
            [ngClass]="{'w-200': zoomScale()===200, 'w-300': zoomScale()===300, 'w-400': zoomScale()===400,
        'w-500': zoomScale()===500}"
          ></image-cropper>
        </div>
      }
      @if (openCropper() && !!imgBase64() && imageFromCollection()) {
        <div>
          <image-cropper
            [imageBase64]="imgBase64()"
            [maintainAspectRatio]="useRatio()"
            [roundCropper]="page()==='profile'"
            [aspectRatio]="ratioX() / ratioY()"
            [imageQuality]="80"
            output="blob"
            format="webp"
            (imageCropped)="imageCroppedInFile($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
            [ngClass]="{'w-200': zoomScale()===200, 'w-300': zoomScale()===300, 'w-400': zoomScale()===400,
        'w-500': zoomScale()===500}"
          ></image-cropper>
        </div>
      }
    }


    <div class="cropper-grid">
      @if (!openCropper()) {
        <img [ngClass]="{'cropper-img': img(), 'profile-page-crop': page()==='profile'}" [src]="getImage(img())" />
      }
      <div [ngClass]="{'no-image-grid': !img()}" class="buttons-container">
        <input [id]="id" class="file-input-hide" type="file" (change)="fileChangeEvent($event)" />
        @if (showAvatarImage() && !openCropper() && !file()) {
          <label [for]="id" class="file-input-label">
            <mat-icon title="{{'main.upload' | translate}}">file_upload</mat-icon>
          </label>
        }

        @if (!openCropper() && page() === 'event') {
          <label class="file-input-label" (click)="choosePicture()">
            <mat-icon title="{{'event.choose_from_collection' | translate}}">collections</mat-icon>
          </label>
        }

        @if (!openCropper() && page() === 'event' && img()) {
          <label class="file-input-label" (click)="deleteImage()">
            <mat-icon title="{{'main.delete' | translate}}">delete_forever</mat-icon>
          </label>
        }

        @if (!openCropper() && (!!imgEvent() || !!imgBase64()) && !file()) {
          <label class="file-input-label"
            (click)="cropImage()">
            <mat-icon title="{{'event.crop_image' | translate}}">crop</mat-icon>
          </label>
        }

        @if (showUndo()) {
          <label class="file-input-label" (click)="undoImage()">
            <!--<span>{{'event.undo_changes' | translate}}</span>-->
            <mat-icon title="{{'event.undo_changes' | translate}}">undo</mat-icon>
          </label>
        }

        @if (!showAvatarImage()) {
          <label class="file-input-label" (click)="saveAvatar()">
            <mat-icon title="{{'Confirm' | translate}}">done</mat-icon>
            @if (showCropMessage()) {
              <div class="crop-message">{{'event.crop_message' | translate}}</div>
            }
          </label>
        }

        @if (!showAvatarImage() && !hideRatio()) {
          <label class="file-input-label" (click)="cancelAvatar()">
            <mat-icon title="{{'Cancel' | translate}}">clear</mat-icon>
          </label>
        }

        <!--          remove image-->
        @if (!showAvatarImage() && hideRatio() && !file()) {
          <label class="file-input-label" (click)="removeNewImg()">
            <mat-icon title="{{'Cancel' | translate}}">clear</mat-icon>
          </label>
        }
</div>
</div>
</div>



@if (!showAvatarImage() && !hideRatio()) {
  <div class="cropper-grid ratio-grid">
    <mat-checkbox (change)="chooseRatio($event.checked)" style="float: right; margin-right: 10px"
      [labelPosition]="'before'">
      {{'main.ratio' | translate}}
    </mat-checkbox>
    @if (!showAvatarImage()) {
      <label class="file-input-label" (click)="setRatio(1, 1)"
        [ngClass]="{'checked-ratio' : ratioX()===1, 'disabled-ratio': !useRatio()}">
        <div class="ratio-value">1:1</div>
      </label>
    }
    @if (!showAvatarImage()) {
      <label class="file-input-label" (click)="setRatio(16, 9)"
        [ngClass]="{'checked-ratio' : ratioX()===16, 'disabled-ratio': !useRatio()}">
        <div class="ratio-value">16:9</div>
      </label>
    }
    @if (!showAvatarImage()) {
      <label class="file-input-label" (click)="setRatio(4, 3)"
        [ngClass]="{'checked-ratio' : ratioX()===4, 'disabled-ratio': !useRatio()}">
        <div class="ratio-value">4:3</div>
      </label>
    }
  </div>
}
</div>
</div>
